import { Buffer } from 'buffer'

function padString(input: string) {
    let segmentLength = 4
    let stringLength = input.length
    let diff = stringLength % segmentLength

    if (!diff) {
        return input
    }

    let position = stringLength
    let padLength = segmentLength - diff
    let paddedStringLength = stringLength + padLength
    let buffer = Buffer.alloc(paddedStringLength)

    buffer.write(input)

    while (padLength--) {
        buffer.write('=', position++)
    }

    return buffer.toString()
}

function toBase64(base64url: string) {
    // We this to be a string so we can do .replace on it. If it's
    // already a string, this is a noop.
    base64url = base64url.toString()
    return (
        padString(base64url)
            // eslint-disable-next-line no-useless-escape
            .replace(/\-/g, '+')
            .replace(/_/g, '/')
    )
}

export function fromBase64(base64: string) {
    return base64.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_')
}

export function encode(input: string, encoding: BufferEncoding = 'utf8') {
    if (Buffer.isBuffer(input)) {
        return fromBase64(input.toString('base64'))
    }
    return fromBase64(Buffer.from(input, encoding).toString('base64'))
}

export function decode(base64url: string, encoding: BufferEncoding = 'utf8') {
    return Buffer.from(toBase64(base64url), 'base64').toString(encoding)
}
